export default "__VITE_ASSET__cGHgaQd6__"